import Link from 'next/link'
import { cn } from '@/lib/ui/utils'
import LogoDark from '@/assets/logo/LogoDark'
import LogoLight from '@/assets/logo/LogoLight'

type Size = 'small' | 'medium' | 'original'
type Variant = 'light' | 'dark'

export default function Logo({
  variant = 'light',
  size = 'medium',
  mobile,
  className,
}: {
  variant?: Variant
  size?: Size
  mobile?: Size
  className?: string
}) {
  const Icon = variant === 'dark' ? LogoDark : LogoLight
  const mob = mobile ?? size

  return (
    <div className={cn('max-w-max', className)}>
      <Link href="/" aria-label="Zur Startseite">
        {/* mobile */}
        <span className="block md:hidden">
          <Icon size={mob} />
        </span>
        {/* desktop */}
        <span className="hidden md:block">
          <Icon size={size} />
        </span>
      </Link>
    </div>
  )
}
